import { Collapse } from 'antd';
// import SocialMedia from '../forms/socialMedia'
import SocialMediaTest from '../forms/socialMediaTest'

const { Panel } = Collapse;

const SocialMedia = () => {
  const onChange = (key) => {
    console.log(key);
  };
  return (
    <Collapse defaultActiveKey={['0']} onChange={onChange}>
      <Panel header="Social Media" key="1">
      {/* <SocialMedia/> */}
      <SocialMediaTest/>
      </Panel>

    </Collapse>
  );
};
export default SocialMedia;